module.exports = __webpack_public_path__ + "media/5-e.5c2cfce1.wav";